import { collection, getDocs, getFirestore } from 'firebase/firestore';
import {initializeApp} from 'firebase/app';

const firebaseConfig = {
    apiKey: "AIzaSyC77Z6ySfl8IUVm9BJywpFXaQ6nu2ONhdQ",
    authDomain: "ujjalzaman-b6c8a.firebaseapp.com",
    projectId: "ujjalzaman-b6c8a",
    storageBucket: "ujjalzaman-b6c8a.appspot.com",
    messagingSenderId: "311177910809",
    appId: "1:311177910809:web:5a19675fab1e9b03aa6888"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const webPreviewCollectionRef = collection(db, 'website-images');

class WebPreviewDataServices {
    getAllWebPreview = () =>{
        return getDocs(webPreviewCollectionRef);
    }
}
export default new WebPreviewDataServices();